import type {FunctionComponent, SyntheticEvent} from 'react'
import React from 'react'
import clsx from 'clsx'
import {useRouteLoaderData} from '@remix-run/react'
import {FeedbackStar} from '~/icons/feedback-star'
import type {RootLoaderResponse} from '~/types'
import {getDomainConfig} from '~/domains'
import {getTranslation} from '~/localization/translation'
import {AmazonLogoIcon} from '~/icons/amazon-logo-icon'
import SaleEventBadge from '../badges/saleEventBadge'

interface DefaultCtaProps {
  redirectUrl: string
  handleCardClick: (e: SyntheticEvent) => void
  brand?: string
  productScore: string
  showPrimeDayLogo: boolean
  index: number
}
const DefaultCta: FunctionComponent<DefaultCtaProps> = ({
  redirectUrl,
  handleCardClick,
  brand,
  productScore,
  index,
  showPrimeDayLogo,
}) => {
  const {locale, domain, language} = useRouteLoaderData('root') as RootLoaderResponse
  const {domainName, styles: stylesBydomain} = getDomainConfig(domain, locale)

  const translations = getTranslation(language)

  return (
    <>
      <a
        href={redirectUrl}
        onClick={handleCardClick}
        aria-label={`view ${brand}`}
        target="_blank"
        rel="sponsored noreferrer"
        className="flex flex-row items-center gap-3 tablet:hidden"
      >
        <FeedbackStar className="size-7 fill-yellow-450" />
        <p className="text-2xl font-light tracking-wide">
          {productScore}&nbsp;
          {translations.ProductCard.scoreSuffix}
        </p>
      </a>

      {/* -------------------------------------------  CTA  --------------------------------------------- */}

      <div className="flex w-full flex-col gap-3">
        <a
          href={redirectUrl}
          onClick={handleCardClick}
          aria-label={`view ${brand}`}
          target="_blank"
          rel="sponsored noreferrer"
          className={clsx(
            'relative flex h-[50px] w-full flex-row items-center justify-center gap-8 rounded-3xl px-3',
            stylesBydomain.LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY,
            'tablet:h-11',
            'listpage_button_new_layout_primary',
          )}
        >
          <div
            className={clsx(
              'absolute left-3 top-[13px] h-[25px] shrink-0 items-center justify-start rounded-2xl px-2 py-0.5',
              stylesBydomain.LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG,
              stylesBydomain.LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_ICON,
              stylesBydomain.LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_TEXT,
              'tablet:top-2.5',
              'listpage_badge_cta_marketplace_logo_bg listpage_badge_cta_marketplace_logo_text listpage_badge_cta_marketplace_logo_icon',
            )}
          >
            <AmazonLogoIcon
              className={clsx(
                'mt-1 h-4 shrink-0',
                domainName === 'bestestaubsauger' ||
                  (domainName === 'bestexpertschoice' && locale.toLowerCase() === 'ca')
                  ? 'w-14'
                  : 'w-11',
              )}
              domainName={domainName}
            />
          </div>
          <p className="ml-2 text-base font-semibold capitalize tablet:ml-5">{translations.ProductCard.checkPrice}</p>
        </a>
        {showPrimeDayLogo && (
          <SaleEventBadge
            redirectUrl={redirectUrl}
            handleCardClick={handleCardClick}
            brand={brand ?? ''}
            index={index}
            placement="top-picks-card"
          />
        )}
      </div>
    </>
  )
}

export default DefaultCta
